import generateUniqueId from './generateUniqueId';
import {get, set} from './storage'

const cookieName = 'tickaroo-tika';

let _uid = get(cookieName);

function uid(useCookie: boolean) {
  if(useCookie) {
    if (!_uid) {
      _uid = generateUniqueId();
      set(cookieName, _uid);
    }

    return _uid
  } else {
    return null
  }
}

const sid = generateUniqueId()
let referrer: string|undefined = undefined
let uaLocation: string|undefined = undefined

export default function globals(useCookie: boolean) {
  if(uaLocation === undefined) {
    uaLocation = window.location.href.substring(0, 2048 )
  }
  if(referrer === undefined) {
    referrer = document.referrer ? document.referrer.substring(0, 2048) : "";
  }


  return {
    uid: uid(useCookie),
    sid,
    uaLocation: uaLocation,
    uaReferrer: referrer
  }
}
